import orange0Marker from "../assets/images/Warning0Marker.png";
import red0Marker from "../assets/images/Danger0Marker.png";
import green0Marker from "../assets/images/Green0Marker.png";
import sleep0Marker from "../assets/images/Sleep0Marker.png";
import orange1Marker from "../assets/images/Warning1Marker.png";
import red1Marker from "../assets/images/Danger1Marker.png";
import green1Marker from "../assets/images/Green1Marker.png";
import sleep1Marker from "../assets/images/Sleep1Marker.png";
import orange2Marker from "../assets/images/Warning2Marker.png";
import red2Marker from "../assets/images/Danger2Marker.png";
import green2Marker from "../assets/images/Green2Marker.png";
import sleep2Marker from "../assets/images/Sleep2Marker.png";
import orange3Marker from "../assets/images/Warning3Marker.png";
import red3Marker from "../assets/images/Danger3Marker.png";
import green3Marker from "../assets/images/Green3Marker.png";
import sleep3Marker from "../assets/images/Sleep3Marker.png";
import orange4Marker from "../assets/images/Warning4Marker.png";
import red4Marker from "../assets/images/Danger4Marker.png";
import green4Marker from "../assets/images/Green4Marker.png";
import sleep4Marker from "../assets/images/Sleep4Marker.png";
import orange5Marker from "../assets/images/Warning5Marker.png";
import red5Marker from "../assets/images/Danger5Marker.png";
import green5Marker from "../assets/images/Green5Marker.png";
import sleep5Marker from "../assets/images/Sleep5Marker.png";
import orange6Marker from "../assets/images/Warning6Marker.png";
import red6Marker from "../assets/images/Danger6Marker.png";
import green6Marker from "../assets/images/Green6Marker.png";
import sleep6Marker from "../assets/images/Sleep6Marker.png";
import orange7Marker from "../assets/images/Warning7Marker.png";
import red7Marker from "../assets/images/Danger7Marker.png";
import green7Marker from "../assets/images/Green7Marker.png";
import sleep7Marker from "../assets/images/Sleep7Marker.png";
import orange8Marker from "../assets/images/Warning8Marker.png";
import red8Marker from "../assets/images/Danger8Marker.png";
import green8Marker from "../assets/images/Green8Marker.png";
import sleep8Marker from "../assets/images/Sleep8Marker.png";
import orange9Marker from "../assets/images/Warning9Marker.png";
import red9Marker from "../assets/images/Danger9Marker.png";
import green9Marker from "../assets/images/Green9Marker.png";
import sleep9Marker from "../assets/images/Sleep9Marker.png";
import orange10Marker from "../assets/images/Warning10Marker.png";
import red10Marker from "../assets/images/Danger10Marker.png";
import green10Marker from "../assets/images/Green10Marker.png";
import sleep10Marker from "../assets/images/Sleep10Marker.png";
import orange11Marker from "../assets/images/Warning11Marker.png";
import red11Marker from "../assets/images/Danger11Marker.png";
import green11Marker from "../assets/images/Green11Marker.png";
import sleep11Marker from "../assets/images/Sleep11Marker.png";
import orange12Marker from "../assets/images/Warning12Marker.png";
import red12Marker from "../assets/images/Danger12Marker.png";
import green12Marker from "../assets/images/Green12Marker.png";
import sleep12Marker from "../assets/images/Sleep12Marker.png";
import orange13Marker from "../assets/images/Warning13Marker.png";
import red13Marker from "../assets/images/Danger13Marker.png";
import green13Marker from "../assets/images/Green13Marker.png";
import sleep13Marker from "../assets/images/Sleep13Marker.png";
import orange14Marker from "../assets/images/Warning14Marker.png";
import red14Marker from "../assets/images/Danger14Marker.png";
import green14Marker from "../assets/images/Green14Marker.png";
import sleep14Marker from "../assets/images/Sleep14Marker.png";
import orange15Marker from "../assets/images/Warning15Marker.png";
import red15Marker from "../assets/images/Danger15Marker.png";
import green15Marker from "../assets/images/Green15Marker.png";
import sleep15Marker from "../assets/images/Sleep15Marker.png";
import orange16Marker from "../assets/images/Warning16Marker.png";
import red16Marker from "../assets/images/Danger16Marker.png";
import green16Marker from "../assets/images/Green16Marker.png";
import sleep16Marker from "../assets/images/Sleep16Marker.png";
import orange17Marker from "../assets/images/Warning17Marker.png";
import red17Marker from "../assets/images/Danger17Marker.png";
import green17Marker from "../assets/images/Green17Marker.png";
import sleep17Marker from "../assets/images/Sleep17Marker.png";
import orange18Marker from "../assets/images/Warning18Marker.png";
import red18Marker from "../assets/images/Danger18Marker.png";
import green18Marker from "../assets/images/Green18Marker.png";
import sleep18Marker from "../assets/images/Sleep18Marker.png";
import orange19Marker from "../assets/images/Warning19Marker.png";
import red19Marker from "../assets/images/Danger19Marker.png";
import green19Marker from "../assets/images/Green19Marker.png";
import sleep19Marker from "../assets/images/Sleep19Marker.png";

interface ImageArrayType {
  device: string;
  images: {
    type: "warning" | "danger" | "ok" | "sleep";
    image: string;
  }[];
}

export const imageArray: ImageArrayType[] = [
  {
    device: "기타",
    images: [
      { type: "warning", image: orange0Marker },
      { type: "danger", image: red0Marker },
      { type: "ok", image: green0Marker },
      { type: "sleep", image: sleep0Marker },
    ],
  },
  {
    device: "트랙터",
    images: [
      { type: "warning", image: orange1Marker },
      { type: "danger", image: red1Marker },
      { type: "ok", image: green1Marker },
      { type: "sleep", image: sleep1Marker },
    ],
  },
  {
    device: "스피드스프레이어",
    images: [
      { type: "warning", image: orange2Marker },
      { type: "danger", image: red2Marker },
      { type: "ok", image: green2Marker },
      { type: "sleep", image: sleep2Marker },
    ],
  },
  {
    device: "사륜오토바이",
    images: [
      { type: "warning", image: orange3Marker },
      { type: "danger", image: red3Marker },
      { type: "ok", image: green3Marker },
      { type: "sleep", image: sleep3Marker },
    ],
  },
  {
    device: "이륜오토바이",
    images: [
      { type: "warning", image: orange4Marker },
      { type: "danger", image: red4Marker },
      { type: "ok", image: green4Marker },
      { type: "sleep", image: sleep4Marker },
    ],
  },
  {
    device: "1톤 트럭",
    images: [
      { type: "warning", image: orange5Marker },
      { type: "danger", image: red5Marker },
      { type: "ok", image: green5Marker },
      { type: "sleep", image: sleep5Marker },
    ],
  },
  {
    device: "보행관리기",
    images: [
      { type: "warning", image: orange6Marker },
      { type: "danger", image: red6Marker },
      { type: "ok", image: green6Marker },
      { type: "sleep", image: sleep6Marker },
    ],
  },
  {
    device: "승용관리기",
    images: [
      { type: "warning", image: orange7Marker },
      { type: "danger", image: red7Marker },
      { type: "ok", image: green7Marker },
      { type: "sleep", image: sleep7Marker },
    ],
  },
  {
    device: "농업용고소작업차",
    images: [
      { type: "warning", image: orange8Marker },
      { type: "danger", image: red8Marker },
      { type: "ok", image: green8Marker },
      { type: "sleep", image: sleep8Marker },
    ],
  },
  {
    device: "농업용운반차",
    images: [
      { type: "warning", image: orange9Marker },
      { type: "danger", image: red9Marker },
      { type: "ok", image: green9Marker },
      { type: "sleep", image: sleep9Marker },
    ],
  },
  {
    device: "농업용로더",
    images: [
      { type: "warning", image: orange10Marker },
      { type: "danger", image: red10Marker },
      { type: "ok", image: green10Marker },
      { type: "sleep", image: sleep10Marker },
    ],
  },
  {
    device: "승용예초기",
    images: [
      { type: "warning", image: orange11Marker },
      { type: "danger", image: red11Marker },
      { type: "ok", image: green11Marker },
      { type: "sleep", image: sleep11Marker },
    ],
  },
  {
    device: "승용제초기",
    images: [
      { type: "warning", image: orange12Marker },
      { type: "danger", image: red12Marker },
      { type: "ok", image: green12Marker },
      { type: "sleep", image: sleep12Marker },
    ],
  },
  {
    device: "승용이앙기",
    images: [
      { type: "warning", image: orange13Marker },
      { type: "danger", image: red13Marker },
      { type: "ok", image: green13Marker },
      { type: "sleep", image: sleep13Marker },
    ],
  },
  {
    device: "퇴비살포기",
    images: [
      { type: "warning", image: orange14Marker },
      { type: "danger", image: red14Marker },
      { type: "ok", image: green14Marker },
      { type: "sleep", image: sleep14Marker },
    ],
  },
  {
    device: "농약살포기",
    images: [
      { type: "warning", image: orange15Marker },
      { type: "danger", image: red15Marker },
      { type: "ok", image: green15Marker },
      { type: "sleep", image: sleep15Marker },
    ],
  },
  {
    device: "콤바인",
    images: [
      { type: "warning", image: orange16Marker },
      { type: "danger", image: red16Marker },
      { type: "ok", image: green16Marker },
      { type: "sleep", image: sleep16Marker },
    ],
  },
  {
    device: "굴삭기",
    images: [
      { type: "warning", image: orange17Marker },
      { type: "danger", image: red17Marker },
      { type: "ok", image: green17Marker },
      { type: "sleep", image: sleep17Marker },
    ],
  },
  {
    device: "경운기",
    images: [
      { type: "warning", image: orange18Marker },
      { type: "danger", image: red18Marker },
      { type: "ok", image: green18Marker },
      { type: "sleep", image: sleep18Marker },
    ],
  },
  {
    device: "잔가지파쇄기",
    images: [
      { type: "warning", image: orange19Marker },
      { type: "danger", image: red19Marker },
      { type: "ok", image: green19Marker },
      { type: "sleep", image: sleep19Marker },
    ],
  },
];
